<template>
  <v-dialog v-model="dialog" max-width="520">
    <template v-if="$slots.default" v-slot:activator="{ props }">
      <div v-bind="props"><slot /></div>
    </template>
    <v-card class="vb-dialog vb-dialog-danger">
      <v-card-title class="bg-red-darken-3 d-flex justify-space-between">
        {{ title }}

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="btnOk" elevation="0" :disabled="isSubmitting" @click="confirm">
          {{ $t('common.delete') }}
        </v-btn>
        <v-btn variant="text" :disabled="isSubmitting" @click="dialog = false">
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteWebhookIntegrationDialog',
  props: {
    modelValue: {
      type: [Boolean, null],
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue', 'confirm'],
  data() {
    return {
      internalDialog: false,
      isSubmitting: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue ?? this.internalDialog;
      },
      set(value) {
        if (this.modelValue === null) {
          this.internalDialog = value;
          return;
        }
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    async confirm() {
      this.isSubmitting = true;
      this.$emit('confirm');
      this.dialog = false;
      this.isSubmitting = false;
    },
  },
}
</script>
